import type { CanMatchFn } from '@angular/router';

/** Pantallas de Compras que ya son reales. El resto, y el hub, son del prototipo. */
export const SUBMODULOS_REALES_COMPRAS: readonly string[] = ['peticiones', 'compras-producto'];

/**
 * `canMatch` del montaje `compras` de `app.routes.ts`: solo casa con `/compras/peticiones…` y
 * `/compras/compras-producto`. Igual que `esSubmoduloRealDeTesoreria`.
 *
 * Por qué hace falta: sin él, `path: 'compras'` se quedaría con `/compras` entera. Sus hijas no tienen
 * ruta `''`, el router no vuelve atrás a probar el prototipo y el hub no se pintaría. Con `canMatch` en
 * `false` el router SÍ pasa a la siguiente ruta, así que el hub y las demás tarjetas siguen viniendo del
 * prototipo, y las pantallas reales ganan el nivel «Compras» en las migas (Compras › Peticiones de compra
 * › código), con «Compras» enlazando al hub.
 */
export const esSubmoduloRealDeCompras: CanMatchFn = (_route, segments) =>
  SUBMODULOS_REALES_COMPRAS.includes(segments[1]?.path ?? '');
